import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d013d838&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d013d838')) {
      api.createRecord('d013d838', component.options)
    } else {
      api.reload('d013d838', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d013d838&", function () {
      api.rerender('d013d838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/actionAnalysis/index.vue"
export default component.exports